export const classes = {
  message: 'py-4 text-grey-5 text-center text-xl',
};
